import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  permissions: [],
  permission: {
    id: 0,
    name: "",
    description: "",
    code: "",
    status: false,
  },
  permissionValidation: {
    isValid: true,
    name: {
      isValid: true,
      errorMessage: "El campo nombre no debe estar vacio",
    },
    description: {
      isValid: true,
      errorMessage: "El campo descripcion no debe estar vacio",
    },
    code: {
      isValid: true,
      errorMessage: "El campo código no debe estar vacio",
    },
  },
};

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    restartState(state) {
      state.permission = {};
      state.permissions = [];
    },
    setpermissions(state, actions) {
      state.permissions = actions.payload.permissions;
      state.permission = {};
    },
    setpermission(state, actions) {
      state.permission = actions.payload.permission;
      state.permissions = [];
    },
    modifyPropertyValue(state, actions) {
      state.permission[actions.payload.id] = actions.payload.value;
    },
    setpermissionValidation(state, actions) {
      state.permissionValidation = {
        name: {
          ...state.permissionValidation.name,
          isValid: actions.payload.name !== "",
        },
        code: {
          ...state.permissionValidation.code,
          isValid: actions.payload.code !== "",
        },
      };
      state.permissionValidation.isValid =
        state.permissionValidation.code.isValid;
    },
    setFieldValid(state, actions) {
      state.permissionValidation[actions.payload.id].isValid = actions.payload.value;
    },
  },
});

export const permissionActions = permissionSlice.actions;
export default permissionSlice;
